<template>
  <!-- Vuetify root -->
  <v-app>
    <!-- If your NavBar component renders a Vuetify v-app-bar internally, keep it here -->
    <NavBar v-if="showNav" />

    <!-- Main content area -->
    <v-main :class="getClassName">
      <!-- Optional container; remove if you want full-bleed -->
      <v-container fluid class="py-0">
        <Errors v-if="errors" />
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Cookies from "js-cookie"
import kebabCase from "lodash/kebabCase" // replace global _ usage

import Errors from "../components/app/Errors.vue"
import NavBar from "../components/app/NavBar.vue"

export default {
  name: "app",
  components: { Errors, NavBar },

  computed: {
    errors() {
      return this.$store.getters["store/errors"]
    },
    showNav() {
      return this.$route.meta.showNav
    },
    getClassName() {
      const name = this.$route?.name ?? ""
      return name ? "page-" + kebabCase(String(name)) : "page-unknown"
    },
  },

  mounted() {
    this.$store.dispatch("store/clearErrors")

    const patient = Cookies.get("patient")
    if (patient !== undefined) {
      this.$store.dispatch("store/setPatient", JSON.parse(patient))
    }

    const signer = Cookies.get("signer")
    if (signer !== undefined) {
      this.$store.dispatch("store/setSigner", JSON.parse(signer))
    }
  },
}
</script>

<style lang="scss" scoped>
/* Example: tiny layout polish */
:deep(.v-main) { min-height: 100vh; }
</style>
